/* eslint-disable no-restricted-syntax, no-await-in-loop */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { applyPromotion, orderProduct, removeLineItemsFromOrder } from 'shared/api/apiOrder';

export const doAddToCart = createAsyncThunk(
  'cart/doAddToCart',
  async (forms) => {
    for (const form of forms) {
      await orderProduct(form);
    }
  }
);

export const destroyLineItems = createAsyncThunk(
  'cart/destroyLineItems',
  (lineItemIds) => removeLineItemsFromOrder(lineItemIds),
);

export const applyBlackFridayPromotion = createAsyncThunk(
  'cart/applyBlackFridayPromotion',
  (args) => applyPromotion(args),
);